import { render, staticRenderFns } from "./list.vue?vue&type=template&id=7bf0ff5f&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf0ff5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf0ff5f')) {
      api.createRecord('7bf0ff5f', component.options)
    } else {
      api.reload('7bf0ff5f', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=7bf0ff5f&scoped=true", function () {
      api.rerender('7bf0ff5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/splitting/list.vue"
export default component.exports